module.exports = __webpack_public_path__ + "static/media/dave.58882bbc.jpg";